<template>
  <div v-if="systemAlert" id="system-alert" style="position: fixed; width: 100%; z-index: 1">
    <v-alert
      v-model="showAlert"
      dismissible
      dense
      transition="slide-y-transition"
      :icon="systemAlert.success ? 'mdi-checkbox-marked-circle-outline' : 'mdi-alert-circle-outline'"
      :type="systemAlert.success ? (onsiteMode ? 'info' :'success') : 'warning'"
      border="left"
      elevation="2"
      class="pr-2"
    >
      <span slot="default" v-html="systemAlert.message"></span>

      <div slot="close" @click="close" style="position: relative">
        <div style="position: absolute; height: 45px; width: 45px" class="fixed-center"></div>
        <v-icon size="16">mdi-close</v-icon>
      </div>
    </v-alert>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "SystemAlert",
  data: () => ({
    showAlert: false,
  }),
  computed: {
    ...mapState(["systemAlert"]),
  },
  methods: {
    ...mapMutations(["updateSystemAlert"]),
    close() {
      this.showAlert = false;
      this.updateSystemAlert(null);
    },
  },
  watch: {
    systemAlert(newValue, oldValue) {
      if (newValue && newValue.show) {
        this.showAlert = true;

        // setTimeout(() => {
        //   this.showAlert = false;
        //   this.updateSystemAlert(null);
        // }, 3000);
      } else {
        this.close();
      }
    },
  },
};
</script>